'use strict';

import React from 'react';

export default function TackIcon() {

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18px' height='18px' viewBox='0 0 18 18' version='1.1'>
      <g id='1544---Pinning' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
          <g id='1544---Pinning-1' transform='translate(-1302.000000, -45.000000)' fill='#DCDCDC'>
          <path xmlns='http://www.w3.org/2000/svg' d='M1313.92827,
          53.83584 L1317.28952,50.457825 C1318.15576,
          50.685525 1319.08406,50.61267 1319.91054,50.23854 L1314.69806,
          45 C1314.32584,45.83061 1314.2533,46.763505 1314.47987,
          47.63412 L1311.1187,51.012135 C1309.54401,50.25861 1307.70797,
          50.240835 1306.12088,50.959215 L1309.03173,53.884665 L1302,
          63 L1311.06999,55.933155 L1313.98088,58.858605 C1314.69564,
          57.26367 1314.67804,55.418355 1313.92827,53.83584 L1313.92827,
          53.83584 Z M1308.51555,52.224885 C1308.51555,52.224885 1307.7737,
          51.479325 1307.56079,51.27831 C1309.21872,50.79204 1310.30893,
          51.472845 1310.30893,51.472845 C1309.29613,51.155145 1308.51555,
          52.224885 1308.51555,52.224885 L1308.51555,52.224885 Z' id='Shape'/>
          </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./shared/common/svgs/TackIcon/index.js